import { useAuthStore } from '../store/authStore'
import { getShortToken, JwtPayload, parseJwtToken, timestampToLocaleString } from './token'
import { setUserId } from 'firebase/analytics'
import { firebaseAnalytics } from '../firebaseConfig'
import { breadcrumb } from './sentry'
import { ConsoleManager } from '../services/console/ConsoleManager'
import { useDevStore } from '../store/devStore'
import { resetUserScopedState } from '../store/appStore'

export const setToken = (token: string, payload: JwtPayload | null = null) => {
    const jwt_payload = payload ?? parseJwtToken(token)
    useAuthStore.setState({ idToken: token, payload: jwt_payload })
    const shortToken = getShortToken(token)

    console.info('[Auth] Token has been set successfully')
    console.info('[Auth] Short token:', shortToken)
    console.info('[Auth] Token payload:', jwt_payload)
    console.info('[Auth] Token authentication time:', timestampToLocaleString(jwt_payload?.auth_time))
    console.info('[Auth] Token expires at:', timestampToLocaleString(jwt_payload?.exp))

    setUserId(firebaseAnalytics, jwt_payload.sub ?? null)

    if (useDevStore.getState().enableLogging) {
        ConsoleManager.getInstance().enableLogging()
    }

    breadcrumb('Auth', 'Token has been set successfully', { short_token: shortToken })
}

export const clearAuth = () => {
    // The next login may be a different user on a shared device, so nothing user-scoped may
    // survive the sign-out (MD-1418). Reset before clearing the auth store so logout
    // observers never see the previous account's data.
    resetUserScopedState()
    useAuthStore.setState({ idToken: null, payload: null })
    console.info('[Auth] Auth cleared.')
    breadcrumb('Auth', 'Auth cleared.')
}
